export default "__VITE_ASSET__DaVHj5pB__"